<template>
  <v-btn icon x-small color="black" @click="emitClick">
    <v-icon>mdi-pencil</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "TableEditButton",

  methods: {
    emitClick() {
      this.$emit("click");
    }
  }
};
</script>
